import { Route, Routes } from 'react-router-dom';
import ClinicInformationPage from './clinicInformationPage';
import NoticeDetailPage from './noticeDetailPage';
import NoticeListPage from './noticeListPage';
import StaffListPage from './staffListPage';

const SettingRouter = () => {
  return (
    <>
      <Routes>
        <Route path="clinic" element={<ClinicInformationPage />} />
        <Route path="staff/list" element={<StaffListPage />} />
        <Route path="notice/list" element={<NoticeListPage />} />
        <Route path="notice/:noticeId" element={<NoticeDetailPage />} />
      </Routes>
    </>
  );
};

export default SettingRouter;
